<template>
<div class="chapter">
<div class="inner_page">
<div>
<p><br/><br/><br/></p>
<p class="center"><span class="big">un<sub>^</sub>common<br/>     courtesy</span><br/></p>
<p class="center"><img alt="Uncommon Courtesy: The Basics of Good Behavior for a Badly Behaved World, by Jennifer M Wood. Adams Media." src="OEBPS/images/title.jpg"/><br/><br/></p>
<p class="center"><span class="big2">The Basics of <br/>Good Behavior</span><br/></p>
<p class="center"><span class="big1"><strong>For A Badly Behaved World</strong></span><br/><br/><br/><br/></p>
<p class="center">JENNIFER M. WOOD<br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2200e59a